// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1984":"a1826831","2623":"5c0e0c9f"}[chunkId] + ".chunk.css";
};